document.addEventListener("DOMContentLoaded", init);

function init() {
  addEventHoverVariationImage();
  initVariationSwiper();
}

function initVariationSwiper() {
  const swiperEl = document.getElementById(
    "c-main-product-pdp-hero-info-variation-swiper"
  );
  if (swiperEl) {
    const options = {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 0,
      slidesPerView: 4.5,  //コンテンツ　（`swiper-slide`）の数
      breakpoints: {
        768: {
          slidesPerView: 6
        },
        1024: {
           slidesPerView: 6
         },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        slideChange: function (swiper) {},
      },
    };
    initializeSwiper(swiperEl, options);
  }
}

function addEventHoverVariationImage() {
  const titleElement = document.querySelector(
    ".variation-collection-name .title"
  );
  const initialTitle = titleElement.textContent;
  const variantSlides = document.querySelectorAll(
    ".pdp-hero-info-variation .swiper-slide"
  );

  variantSlides.forEach((slide) => {
    slide.addEventListener("mouseenter", function () {
      const variantTitle = slide.querySelector(
        ".visible-variant-title"
      ).textContent;
      titleElement.textContent = variantTitle;
    });

    slide.addEventListener("mouseleave", function () {
      titleElement.textContent = initialTitle;
    });
  });
}
